/**
* Nom : categoryList.js
* Description : Ce fichier contient la définition de la page categoryList 
*               Cette page liste les catégories  
* Date de création : 23 septembre 2024
*/

/* CSS et assets */
import { AddIcon } from 'package_ui_ihm/dist'
import { DeleteIcon } from 'package_ui_ihm/dist'

/* Bibliothèques et composants */
import { TabRD } from 'package_ui_ihm/dist'
import { Container } from 'package_ui_ihm/dist'
import { Item } from 'package_ui_ihm/dist'
import { InputFormSide } from 'package_ui_ihm/dist'
import Divider from '@mui/material/Divider';

/* Hook */
import { useState, useEffect } from 'react';
import { useBlocker } from 'react-router-dom'
import { useAuth } from 'package_ui_ihm/dist'
import { useApi } from 'package_ui_ihm/dist'
import { useScreenWidth } from 'package_ui_ihm/dist'


/**
* CategoryList : affiche la page qui liste les catégories
*                un lien permet d'afficher un formulaire pour créer une nouvelle catégorie
*                pour chaque catégorie une icone permet de la supprimer
*
* Type : page 
*
* Parametres : 
*  None
*/
function CategoryList() {

  // Define useState hooks

  const [categories, setCategories] = useState([])
  const [statusCategory, setStatusCategory] = useState(null)
  const [isDataLoading, setDataLoading] = useState(false)
  const [isCreation, setCreation] = useState(false)
  const [name, setName] = useState(null);
  const [nextionId, setNextionId] = useState(0);
  const [nameError, setNameError] = useState(false);
  const [nextionIdError, setNextionIdError] = useState(false);
  const [isFormClicked, setFormClicked] = useState(false);


  // Define useContext hooks
  const { authStatus, authToken } = useAuth();
  const { path } = useApi();


  // Define useBlocker hooks
  const shouldBlock = isCreation;
  const blocker = useBlocker(shouldBlock);


  // Define useScreenWidth hooks
  const screenWidth = useScreenWidth();


  // Define functions
  async function retrieveData() {
    // Token
    const token = "Bearer " + authToken
    // Categories
    const resCategory = await fetch(path + "/api/bo-cary/", 
      {
        method: 'GET',
        credentials: 'include',
        mode: 'cors',
        headers: {
            accept: 'application/json',
            Authorization: token,
        },
      }
    );
    const dataCategory = await resCategory.json();
    setStatusCategory(resCategory["status"])
    setCategories(dataCategory["results"])
    // Dataloading
    setDataLoading(false)
  }

  const handleClick = (event) => {
    event.preventDefault();
    setCreation(true)
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setFormClicked(true)
    if(name === null || name === ''){
      setNameError(true)
    }
    else
    {   
      setNameError(false)
    }
    if(nextionId === 0 || nextionId === '0'){
      setNextionIdError(true)
    }
    else
    {   
      setNextionIdError(false)
    }
  };

  const handleReset = (event) => {
    event.preventDefault();
    setCreation(false)
    setName(null)
    setNameError(false)
    setNextionId(0)
    setNextionIdError(false)
  };

  async function sendData(name, nextionId) {
    // Token
    const token = "Bearer " + authToken
    // Create category
    await fetch(path + "/api/bo-cary/", 
      {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: {
            accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: token,
        },
        body: JSON.stringify({
            "name": name, 
            "image_nextion_id": Number(nextionId)
        })
      }
    );
    setCreation(false)
    setName(null)
    setNextionId(0)
    retrieveData()
    setFormClicked(false)
  }

  const handleIcon = (event, id) => {
    event.preventDefault();
    sendDelete(id)
  };

  async function sendDelete(id) {
    // Token
    const token = "Bearer " + authToken
    // Delete category
    await fetch(path + "/api/bo-cary/" + id + "/", 
      {
        method: 'DELETE',
        credentials: 'include',
        mode: 'cors',
        headers: {
            accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: token,
        }
      }
    );
    retrieveData()
}


  // Define useEffect hooks
  useEffect(() => {
    if(authStatus === 200)
    {
      setDataLoading(true)
      retrieveData()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if(nameError === false && nextionIdError === false && isFormClicked === true){
      sendData(name, nextionId)
    } else {
      setFormClicked(false)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nameError, nextionIdError, isFormClicked])

  useEffect(() => {
      // Bloquer la fermeture d'onglet/rafraîchissement
      const handleBeforeUnload = (e) => {
      if (shouldBlock === true) {
          // Standard pour afficher une confirmation (les navigateurs modernes gèrent le message)
          e.preventDefault();
          e.returnValue = "";
          // Certains navigateurs nécessitent cette ligne pour afficher la confirmation
          return (e.returnValue = "Cette page vous demande de confirmer sa fermeture ; des données que vous avez saisies pourraient ne pas être enregistrées.");
      }
      }; 

      window.addEventListener("beforeunload", handleBeforeUnload);

      // Nettoyer l'écouteur quand le composant est démonté
      return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldBlock]);

  useEffect(() => {
      if (blocker.state === "blocked") {
          const confirmed = window.confirm(
              "Cette page vous demande de confirmer sa fermeture ; des données que vous avez saisies pourraient ne pas être enregistrées."
          );

          if (confirmed) {
              blocker.proceed();
          } else {
              blocker.reset();
          }
      }
  }, [blocker]);


  // Render component
  return (
    <div>
      <TabRD tabNumber={4}/>
      <div className={(screenWidth > 650) ? 'App' : 'App-ss'}>
        <Container>
          {isDataLoading ? (
            <p>Chargement des données</p>
          ) : (
            (statusCategory === 200) ? (
              <div>
                <h1>Catégories</h1>
                <div className={(screenWidth > 650) ? 'grid-1-3' : null}>
                  {/*New*/}
                  <div className='flex-column'>
                    <div className='link' onClick={handleClick}>
                      <img src={AddIcon} alt='add_item_icon' className='link-img' />
                      <div className='link-text'>Catégorie</div>
                    </div>
                    {(isCreation === true) ? (
                      <div className='flex-rows'>
                        <h3>Nouvelle catégorie</h3>
                        <form onSubmit={handleSubmit} onReset={handleReset} className='flex-column'>
                          <div className='flex-column form-center'>
                            <InputFormSide error={nameError} type="text" label="Nom" value={name} setValue={setName}/>
                            <InputFormSide error={nextionIdError} type="number" label="Image Nexion ID" value={nextionId} setValue={setNextionId}/>
                          </div>
                          <div className='flex-row form-center'>
                            <button type="reset" className='button'>Annuler</button>
                            <button type="submit" className='button'>Valider</button>
                          </div>
                        </form> 
                      </div>
                    ) : (
                      <div></div>
                    )}
                  </div>
                  {(screenWidth > 650) ? null : <Divider/>}
                  {/*Categories list*/}
                  <div className='scroll-list-rd'>
                    <h2 className='subtitle'>Nombre de catégories : {categories.length}</h2>
                    {(categories && categories.length !== 0) ? (
                      categories.sort((a, b) => (a.name > b.name)?1:-1).map((category) => (
                        <Item key={category['id']} id={category['id']}>
                          <div className='grid-1-1-2'>
                            <h3 className='item-text'>{category['name']}</h3> 
                            <p className='item-text'>Image Nextion ID : {category['image_nextion_id']}</p>
                            <div className='flex-row justify-end'>
                              <div/>
                              {/*<img src={EditIcon} alt='edit_item_icon' className='link-img link-icon' />*/}
                              <img src={DeleteIcon} alt='delete_item_icon' onClick={(e) => handleIcon(e, category['id']) } className='link-img'/>
                            </div>
                          </div>
                        </Item>
                      ))
                    ) : (
                      <p>Aucune catégorie actuellement. Veuillez en créer une !</p>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              <h1>Connexion failed</h1>
            )
          )}
        </Container>
      </div>
    </div>
  );
}

export default CategoryList;
